import { Box, Typography } from '@mui/material'
import React from 'react'
import styles from '../../styles/components/noResultTable.module.scss'
import SadGrayIcon from '../../public/assets/icons/SadGrayIcon'

const NoResultTable = ({errText}) => {

  return (
    <Box className={styles.noResultWrapper}>
        <SadGrayIcon/>
        <Typography variant='body1'>{errText? errText : "We couldn't find any published videos within the specified date range."}</Typography>
    </Box>
  )
}

export default NoResultTable